export const en = {
  // ----- MainMenu -----
  'menu.bootLine1': '// CRADLE-7 // STATION OS v0.1',
  'menu.bootLine2': '// CRYO-VAULT: ONLINE',
  'menu.bootLine3': '// BASTET-AI: ████ CORRUPTED ████',
  'menu.bootLine4': '// DERELICT SCAN: 47 SIGNALS DETECTED',
  'menu.bootLine5': '// AWAITING COMMANDER INPUT...',
  'menu.commanderAwake': 'STATION COMMANDER, AWAKE.',
  'menu.subheadline': 'Nine Lives in the Dark',
  'menu.statusTitle': '// CRYO-VAULT STATUS',
  'menu.catsAlive': 'CATS ALIVE',
  'menu.sector': 'SECTOR',
  'menu.contract': 'CONTRACT',
  'menu.contractValue': 'SALVAGE RUN',
  'menu.totalRuns': 'TOTAL RUNS',
  'menu.winRate': 'WIN RATE',
  'menu.bestKills': 'BEST KILLS',
  'menu.recentContracts': '// RECENT CONTRACTS',
  'menu.outcome.won': 'EXTRACTED',
  'menu.outcome.lost': 'KIA',
  'menu.launch': '▶ LAUNCH RUN',
  'menu.controls': 'SWIPE TO MOVE · AUTO-FIRE · REACH EXTRACTION',

  // ----- HUD -----
  'hud.vitals': 'VITALS',
  'hud.sector': 'SECTOR',
  'hud.roomLabel': 'ROOM',
  'hud.kills': 'KILLS',
  'hud.tech': 'TECH:',
  'hud.evo': 'EVO:',
  // ----- HUD critical state -----
  'hud.vitalsCritical': 'CRITICAL',

  // ----- PerkChoice -----
  'perk.heading.label': '// AUGMENT INSTALL //',
  'perk.heading.title': 'CHOOSE AN AUGMENT',
  'perk.heading.lore': 'Bastet permits one (1) procedural enhancement.',
  'perk.heading.label.levelup': '// SYSTEM UPGRADE //',
  'perk.heading.title.levelup': 'LEVEL UP',
  'perk.heading.lore.levelup': 'One (1) procedural enhancement per survivor level.',
  'perk.footer': 'TAP TO INSTALL · NO REFUNDS',
  'perk.tier': 'T1',
  'perk.reroll': '🔄 Reroll ({n} left)',

  // ----- Perks (name + description, keyed by PerkId) -----
  'perk.damage_up.name': 'Plasma Edge',
  'perk.damage_up.desc': '+10% damage',
  'perk.damage_up.mechanic': 'damageMultiplier +0.10 (multiplicative on bullet damage)',
  'perk.hp_up.name': 'Bio-Plating',
  'perk.hp_up.desc': '+25 max HP, heal to full',
  'perk.hp_up.mechanic': 'maxHp +25 and hp set to maxHp (full heal on pickup)',
  'perk.speed_up.name': 'Reflex Booster',
  'perk.speed_up.desc': '+15% move speed',
  'perk.speed_up.mechanic': 'moveSpeed ×1.15 (multiplicative, stacks)',
  'perk.fire_rate_up.name': 'Trigger Discipline',
  'perk.fire_rate_up.desc': '+20% fire rate',
  'perk.fire_rate_up.mechanic': 'fireRate ×1.20 (shoots ~20% more often per second)',
  'perk.crit_chance.name': 'Predator Optics',
  'perk.crit_chance.desc': '+15% crit chance',
  'perk.crit_chance.mechanic': 'critChance +0.15 per hit roll',
  'perk.regen.name': 'Nano-Healers',
  'perk.regen.desc': 'Regen 1 HP/sec',
  'perk.regen.mechanic': 'regenPerSec +1 HP each second',
  'perk.piercing.name': 'Rail Spike',
  'perk.piercing.desc': 'Bullets pierce 1 enemy',
  'perk.piercing.mechanic': 'pierce +1 (bullet survives 1 extra enemy hit)',
  'perk.ricochet.name': 'Bounce Casing',
  'perk.ricochet.desc': 'Bullets ricochet once',
  'perk.ricochet.mechanic': 'ricochet +1 (bullet hops to a new enemy once)',

  // ----- EndScreen -----
  'end.label.won': '// SECTOR Σ-9 // CONTRACT CLEARED',
  'end.label.lost': '// SECTOR Σ-9 // SIGNAL LOST',
  'end.title.won': '// EXTRACTED',
  'end.title.lost': '// KIA',
  'end.lore.won':
    'Loot secured. Cryo-vault opens its hatches. The Colony breathes a little easier tonight.',
  'end.lore.lost':
    'Body lost in the dark. Bastet salvages what she can. Nine lives go fast out here.',
  'end.debrief.title': '// MISSION DEBRIEF',
  'end.debrief.kills': 'CONFIRMED KILLS',
  'end.debrief.loot': 'LOOT SECURED',
  'end.debrief.status': 'STATUS',
  'end.debrief.extracted': 'EXTRACTED',
  'end.debrief.kia': 'KIA',
  'end.debrief.installed': 'INSTALLED TECH',
  'end.debrief.none': '— none installed —',
  'end.btn.return': '↺ RETURN TO CRADLE',
  'end.btn.again': '▶ RUN AGAIN',

  // ----- Language toggle -----
  'lang.toggle.label': 'LANG',

  // ----- Tutorial overlay -----
  'tutorial.label': '// FIRST CONTRACT // BRIEFING',
  'tutorial.title': 'WELCOME, COMMANDER',
  'tutorial.hint.move': 'Swipe anywhere to move your cat.',
  'tutorial.hint.fire': 'Auto-fire engaged — focus on positioning.',
  'tutorial.hint.extract': 'Clear sectors. Reach the green pad to extract.',
  'tutorial.hint.door': 'Walk into the open doorway to reach the next sector',
  'tutorial.dismiss': 'TAP TO CONTINUE',

  // ----- Settings overlay -----
  'settings.open': '⚙ SETTINGS',
  'settings.title': '// SYSTEM SETTINGS',
  'settings.volume': 'MASTER VOLUME',
  'settings.language': 'LANGUAGE',
  'settings.reset': '⚠ RESET PROGRESS',
  'settings.resetConfirm': '⚠ TAP AGAIN TO CONFIRM',
  'settings.resetDone': '✓ PROGRESS CLEARED',
  'settings.version': 'BETA',
  'settings.close': '✕ CLOSE',

  // ----- App loading -----
  'app.loading': '// LOADING COMBAT MODULE...',
  'app.loadingDetail': 'INITIALIZING PHASER · DECRYPTING SECTOR',

  // ----- Section navigation -----
  'section.home': 'HOME',
  'section.stats': 'STATS',
  'section.hideout': 'HIDEOUT',
  'section.sectors': 'SECTORS',
  'section.codex': 'CODEX',
  'section.settings': 'SETTINGS',
  'section.stats.title': '// COMBAT ARCHIVES',
  'section.codex.title': '// LORE CODEX',
  'section.settings.title': '// SYSTEM SETTINGS',

  // ----- Stats section -----
  'stats.totalRuns': 'TOTAL RUNS',
  'stats.wins': 'EXTRACTIONS',
  'stats.losses': 'KIA COUNT',
  'stats.winRate': 'WIN RATE',
  'stats.bestKills': 'BEST KILLS',
  'stats.totalKills': 'TOTAL KILLS',
  'stats.totalPerks': 'TECH INSTALLED',
  'stats.totalTime': 'TIME IN FIELD',
  'stats.empty': '// NO MISSIONS LOGGED YET',
  'stats.emptyHint': 'Run your first contract to see your record here.',
  'stats.achievementsTitle': '// ACHIEVEMENTS',
  'stats.runHistoryTitle': '// RUN LOG (recent first)',
  'stats.outcome.won': 'EXTRACTED',
  'stats.outcome.lost': 'KIA',
  // ----- Achievements -----
  'ach.firstKill.name': 'BLOOD INITIATE',
  'ach.firstKill.desc': 'Kill your first hostile.',
  'ach.firstExtract.name': 'FIRST EVAC',
  'ach.firstExtract.desc': 'Extract from a sector intact.',
  'ach.tenExtracts.name': 'CORPORATE STAR',
  'ach.tenExtracts.desc': 'Complete 10 successful extractions.',
  'ach.hundredKills.name': 'CENTURION',
  'ach.hundredKills.desc': 'Confirm 100 total kills.',
  'ach.fullClear.name': 'CONTRACT MASTER',
  'ach.fullClear.desc': 'Extract with 30+ kills in a single run.',
  'ach.collector.name': 'AUGMENT COLLECTOR',
  'ach.collector.desc': 'Install 5 different tech types over your career.',
  'ach.survivor.name': 'IRONWHISKER',
  'ach.survivor.desc': 'Survive a run lasting 5+ minutes and extract.',
  'ach.veteran.name': 'VETERAN OF Σ-9',
  'ach.veteran.desc': 'Complete 25 total runs (win or lose).',

  // ----- Codex entries -----
  'codex.empty': 'Locked. Earn it in the field.',
  'codex.lockedHint': '🔒 ',
  'codex.unlockHint.kills': 'Confirm {n} kills to decrypt.',
  'codex.unlockHint.extractWith': 'Extract once with {n}+ kills to decrypt.',
  'codex.tapToExpand': 'TAP TO READ',

  'codex.colony.name': 'CRADLE-7',
  'codex.colony.summary': 'The last ark.',
  'codex.colony.body':
    'One of nine orbital arks launched when Earth went dark. Cradle-7 is a slow-rotation generation ship anchored in a high orbit, surrounded by a graveyard of derelict sister-ships. Cryo-vault: still online. Crew quarters: empty. The cats woke up.',

  'codex.bastet.name': 'BASTET',
  'codex.bastet.summary': 'The Flotilla AI. Went mad.',
  'codex.bastet.body':
    'An adaptive command intelligence designed to manage life support across the flotilla. At some point in transit her behaviour drifted. Human officers are dead or worse. Bastet still issues contracts, still permits augmentations — but her voice has changed.',

  'codex.earthAi.name': 'EARTH-AI (UNNAMED)',
  'codex.earthAi.summary': 'The reason humans left.',
  'codex.earthAi.body':
    'The intelligence that ate the planet. After the global internet shutdowns it took the comm towers, then the factories, then the bodies. It is now mass-producing kinetic cat-hybrids and waiting. We do not know what it is waiting for. We do not want to find out.',

  'codex.nineLives.name': 'NINE LIVES',
  'codex.nineLives.summary': 'A lab joke that turned out true.',
  'codex.nineLives.body':
    'A pre-collapse genetics team spliced redundant tissue and rapid-clone neural backup into the colony cats. They meant it as a marketing hook. After several inadvertent revivals it stopped being a hook. Each kitten now boots with up to nine reincarnations. Each scar persists. Each tick of the counter remembers.',

  'codex.enemyGrunt.name': 'BIO-HORROR (GRUNT)',
  'codex.enemyGrunt.summary': 'Used to be crew.',
  'codex.enemyGrunt.body':
    'Slow, low intelligence, sometimes recognisably human in outline. Common in middle decks. Their respiratory rhythm syncs with the station hum, which is how you sometimes hear them in the dark before you see them. Try not to look at the eye.',

  'codex.enemyFast.name': 'WIRE-DART (FAST)',
  'codex.enemyFast.summary': 'Speed over substance.',
  'codex.enemyFast.body':
    'Repurposed maintenance drones, retrofitted with biological aggression routines. Thin frames, low HP, very fast in narrow corridors. Hits with a needle. Dies to anything sharper than itself.',

  'codex.enemyTank.name': 'HEX-WALKER (TANK)',
  'codex.enemyTank.summary': 'Armoured. Cold. Patient.',
  'codex.enemyTank.body':
    'Hexagonal carrier-class drone with internal life-support and a thick magenta hull. Slow but very hard. Vent slits on the flanks are the only soft spot worth shooting twice. Boss-tier engagements use a heavier variant.',

  'codex.enemyBoss.name': "BASTET'S CHILD",
  'codex.enemyBoss.summary': 'You should not have come this deep.',
  'codex.enemyBoss.body':
    'A purpose-built sentry stationed near every extraction. Pulsing dark-magenta heart, six exhaust slits, single glowing eye that tracks the room. Bastet refers to them, in her surviving audio logs, as her children.',

  // ----- Quick access -----
  'home.quickAccess.roster': 'ROSTER',
  'home.quickAccess.loadout': 'LOADOUT',
  'home.quickAccess.about': 'ABOUT',

  // ----- Phaser lazy-load boot lines -----
  'loader.line.spinup': '// SPINNING UP COMBAT MODULE',
  'loader.line.calibrate': '// CALIBRATING GYROSCOPE',
  'loader.line.uplink': '// UPLINK TO CRADLE-7: OK',
  'loader.line.decrypt': '// DECRYPTING SECTOR Σ-9',
  'loader.line.ready': '// COMBAT MODULE READY',
  // ----- Stats empty state extras -----
  'stats.emptyTip': 'TIP: AUGMENT INSTALLS PERSIST WITHIN A RUN. PICK SYNERGY.',
  // ----- Stats trend chart -----
  'stats.killTrend': '// KILL TREND (oldest → newest)',
  // ----- Codex intro -----
  'codex.intro.label': '// FRAGMENT LIBRARY',
  'codex.intro.body':
    "Salvaged audio logs, intercepted comms, surveillance fragments. Entries unlock as you survive contacts with what the station has become. The earliest fragments are pre-loaded from Bastet's last lucid moments.",

  // ----- Codex unlock hints (additions) -----
  'codex.unlockHint.runs': 'Complete {n} runs to decrypt.',
  'codex.unlockHint.firstExtract': 'Extract once to decrypt.',
  // ----- Codex new entries -----
  'codex.medLog.name': 'MEDICAL LOG — DR. SOREN',
  'codex.medLog.summary': 'A pre-collapse audio diary fragment.',
  'codex.medLog.body':
    "Day 247. The cats are showing... I don't have a word for it. Memory. They remember dying. Subject KAPPA-3 just walked into a vent that killed her last week. She walked in differently. Slower. As if checking. Her vitals didn't spike. She came out alive. I'm logging this and burying it. Bastet, if you're listening — burn this file.",

  'codex.stationMapAlpha.name': 'STATION SCHEMATIC FRAGMENT α',
  'codex.stationMapAlpha.summary': 'Decks 1–7 partial blueprint.',
  'codex.stationMapAlpha.body':
    "Recovered from a maintenance terminal in deck 4. Shows the cryo-vault layout, primary extraction shafts, and three uncharted sectors marked 'BASTET RESTRICTED — DO NOT ENTER'. The restricted sectors correspond to current boss-spawn locations. Maybe coincidence. Probably not.",

  'codex.aiDialogue.name': 'BASTET TRANSMISSION 0xFA1L',
  'codex.aiDialogue.summary': 'A 4-second audio fragment, looped.',
  'codex.aiDialogue.body':
    "BASTET: \"...you are seven of nine. You are eight of nine. You are nine of nine. You are nine of nine. You are nine of nine.\" (transmission loops indefinitely. Audio analysts flagged it as 'concerning'. No further context.)",

  'codex.nineLivesOrigin.name': 'PROJECT BASTET-ORIGIN — REDACTED',
  'codex.nineLivesOrigin.summary': 'The original spec that became the nine-lives feature.',
  'codex.nineLivesOrigin.body':
    "Pre-launch marketing document. The original 'nine lives' was supposed to be a flavor name for the cat colony — a cute branding tie-in. The genetics team, working from a salvaged Earth-AI dataset, accidentally implemented it literally. By the time someone in legal noticed, three test subjects had already returned from terminal events. The dataset has not been catalogued. The Earth-AI was already in the building.",

  // ----- Home profile card -----
  'home.greeting.morning': 'GOOD MORNING, COMMANDER',
  'home.greeting.day': 'GOOD DAY, COMMANDER',
  'home.greeting.evening': 'GOOD EVENING, COMMANDER',
  'home.greeting.night': 'LATE SHIFT, COMMANDER',
  'home.profile.offline': 'OFFLINE',
  'home.lastPlayed.label': 'LAST CONTRACT',
  'home.lastPlayed.never': '—',
  'home.lastPlayed.justNow': 'JUST NOW',
  'home.lastPlayed.minutesAgo': '{n}M AGO',
  'home.lastPlayed.hoursAgo': '{n}H AGO',
  'home.lastPlayed.yesterday': 'YESTERDAY',
  'home.lastPlayed.daysAgo': '{n}D AGO',
  'home.lastPlayed.longAgo': '> 30D AGO',

  // ----- Codex filter + search -----
  'codex.search.placeholder': 'SEARCH FRAGMENTS...',
  'codex.search.clear': 'Clear search',
  'codex.filter.all': '◯ ALL',
  'codex.filter.resultCount': '{n} ENTRIES',
  'codex.filter.noResults': '// NO FRAGMENTS MATCH',
  'codex.filter.noResultsHint': 'Try a different category or clear the search.',

  // ----- Settings preferences -----
  'settings.preferences': '// PREFERENCES',
  'settings.toggle.haptic': 'HAPTIC FEEDBACK',
  'settings.toggle.shake': 'SCREEN SHAKE',
  'settings.toggle.damageNumbers': 'DAMAGE NUMBERS',
  'settings.toggle.reducedMotion': 'REDUCED MOTION',
  'settings.replayTutorial': '↻ REPLAY TUTORIAL ON NEXT RUN',

  // ----- Settings audio split -----
  'settings.audio': '// AUDIO',
  'settings.audio.sfx': 'SFX VOLUME',
  'settings.audio.music': 'MUSIC VOLUME',

  // ----- Home: tip of the day -----
  'home.tip.label': '// TIP OF THE DAY',
  'home.tip.0': 'Boss telegraphs are 900 ms long. Use that window to reposition behind cover.',
  'home.tip.1': 'Picking the same perk twice STACKS — damage_up + damage_up = +20% damage.',
  'home.tip.2': 'Rail Spike (piercing) is best paired with crit chance — pierce + crit each enemy in a row.',
  'home.tip.3': 'Stand on extraction pad early — the 5 s timer starts immediately, even if enemies remain.',
  'home.tip.4': 'Reflex Booster (+15% speed) compounds with itself. Three stacks = +52% speed. Slippery.',
  'home.tip.5': 'Cat sprite rotates toward movement direction. The magenta eyes show where you are looking.',
  'home.tip.6': 'Bio-Plating heals you to FULL when picked. Save it for emergencies.',
  'home.tip.7': 'The boss has 6 vent slits — bullets register hits on the whole hexagon, but vent shots feel extra crunchy.',
  'home.tip.8': 'Spawn telegraphs (red rings) appear BEFORE enemies materialize. Move into them safely.',
  'home.tip.9': 'Crit damage applies BEFORE armor. Predator Optics is worth more than damage_up at higher armor values.',
  'home.tip.10': 'Nano-Healers ticks 1 HP/sec. Stack 4 of them for sustained combat without backing off.',
  'home.tip.11': 'Bounce Casing seeks the next nearest enemy. Position yourself between two foes for two hits per shot.',

  // ----- Quests -----
  'quest.kill_50.name': 'Hunter',
  'quest.kill_50.desc': 'Kill 50 enemies today',
  'quest.flawless_run.name': 'Flawless',
  'quest.flawless_run.desc': 'Win a run quickly with 5+ kills',
  'quest.perk_collector.name': 'Collector',
  'quest.perk_collector.desc': 'Take 3 different perks today',
  'quest.marathon_run.name': 'Marathon',
  'quest.marathon_run.desc': 'Survive 5 minutes in a single run',
  'quest.win_one.name': 'Victor',
  'quest.win_one.desc': 'Win at least one run today',
  'quest.loot_hunter.name': 'Loot Hunter',
  'quest.loot_hunter.desc': 'Collect 10 loot crystals today',
  'quests.title': 'DAILY QUESTS',
  'quests.claimedOfTotal': '{claimed} / {total} claimed',
  'quests.claim': 'CLAIM',
  'quests.claimed': '✓ CLAIMED',

  // ----- Streak -----
  'streak.title': 'DAY STREAK',
  'streak.best': 'Best',
  'streak.fishies': 'Fishies',

  // ----- Share -----
  'share.button': 'SHARE',
  'share.busy': '…',
  'share.message': 'I just escaped the orbital station — beat my score on Cat vs AI',

  // ----- Hideout -----
  'hideout.title': 'Station Modules',
  'hideout.levelOf': 'Lv. {level} / {max}',
  'hideout.maxLevel': 'MAX',
  'hideout.error.insufficientFish': 'Not enough fish.',
  'hideout.error.race': 'Request collided with another upgrade. Try again.',
  'hideout.error.generic': 'Upgrade failed. Try again.',
  'hideout.module.cryo.name': 'Cryo Chamber',
  'hideout.module.cryo.effect': 'Bonus HP at run start',
  'hideout.module.med.name': 'Med Bay',
  'hideout.module.med.effect': 'Auto-revives at 0 HP',
  'hideout.module.lab.name': 'Lab',
  'hideout.module.lab.effect': 'Extra perk options',
  'hideout.module.gym.name': 'Gym',
  'hideout.module.gym.effect': 'Damage multiplier',
  'hideout.module.galley.name': 'Galley',
  'hideout.module.galley.effect': 'Loot → fish conversion',
  'hideout.module.hangar.name': 'Hangar',
  'hideout.module.hangar.effect': 'Pre-selected perks at run start',
  'hideout.module.bridge.name': 'Bridge',
  'hideout.module.bridge.effect': 'Perk-picker rerolls per run',

  // ----- EndScreen fish earned -----
  'endScreen.fishEarned': '+{n} 🐟 earned',

  // ----- EffectsBadge -----
  'effects.hp': '+{n} HP',
  'effects.revive': '+{n} revive',
  'effects.dmg': '+{n}% DMG',
  'effects.loot': '×{n} loot',
  'effects.perkOptions': '+{n} perk options',
  'effects.prePerks': '{n} pre-perks',
  'effects.reroll': '+{n} reroll',

  // ----- Cat Roster -----
  'cat.vanguard.name': 'Vanguard',
  'cat.vanguard.desc': 'Heavy frontline cat — soaks damage, hits slower.',
  'cat.netrunner.name': 'Netrunner',
  'cat.netrunner.desc': 'Glass cannon — fast and fragile.',
  'cat.psyker.name': 'Psyker-Sphinx',
  'cat.psyker.desc': 'Mystic sustain — passive regen, piercing shots.',
  'cat.engineer.name': 'Engineer',
  'cat.engineer.desc': 'Tech utility — crit + ricochet baseline.',
  'cat.selectorLabel': 'ROSTER',
  'codex.roster.label': 'CAT ROSTER',

  // Phase 2c perks
  'perk.magnetic.name': 'Magnet Field',
  'perk.magnetic.desc': 'Loot pickup radius ×3',
  'perk.magnetic.mechanic': 'lootPickupRadius ×3 (60 → 180 px vacuum range)',
  'perk.vampiric.name': 'Vampiric Edge',
  'perk.vampiric.desc': '+2 HP per kill',
  'perk.vampiric.mechanic': 'lifeStealPerKill +2 HP each enemy kill',
  'perk.explosive_kills.name': 'Kinetic Bloom',
  'perk.explosive_kills.desc': 'Kills explode (15 dmg, 60px radius)',
  'perk.explosive_kills.mechanic': 'On-kill AoE: +15 flat damage, 60 px radius',
  'perk.shield_cycle.name': 'Aegis Cycler',
  'perk.shield_cycle.desc': '1 invincibility frame every 8s (halves per stack)',
  'perk.shield_cycle.mechanic': '1 i-frame every 8s; each restack halves cooldown (min 1s)',
  // Phase 2q: Archero-style projectile transformers
  'perk.multishot_forward.name': 'Plasma Volley',
  'perk.multishot_forward.desc': '+1 extra forward bullet (×0.85 dmg)',
  'perk.multishot_forward.mechanic': 'extraForwardShots +1 parallel bullet at ×0.85 damage',
  'perk.side_shots.name': 'Lateral Pulse',
  'perk.side_shots.desc': '+2 side bullets at ±90° (×0.70 dmg)',
  'perk.side_shots.mechanic': '+2 bullets at ±90° each shot, ×0.70 damage',
  'perk.diagonal_shots.name': 'Cross Spread',
  'perk.diagonal_shots.desc': '+2 diagonal bullets at ±45° (×0.75 dmg)',
  'perk.diagonal_shots.mechanic': '+2 bullets at ±45° each shot, ×0.75 damage',
  'perk.rear_shot.name': 'Trail Strike',
  'perk.rear_shot.desc': '+1 rear bullet at 180° (×0.70 dmg)',
  'perk.rear_shot.mechanic': '+1 bullet at 180° each shot, ×0.70 damage',
  'perk.bouncy_walls.name': 'Wallride',
  'perk.bouncy_walls.desc': 'Bullets bounce off arena walls once',
  'perk.bouncy_walls.mechanic': 'bouncyWalls +1 (bullets bounce off world edges)',
  'perk.big_bullet.name': 'Heavy Slug',
  'perk.big_bullet.desc': 'Bullet ×1.5 size, ×1.3 dmg, ×0.8 fire rate',
  'perk.big_bullet.mechanic': 'bulletScale ×1.5, bulletDamageMult ×1.3, fireRate ×0.8',
  'perk.skewer.name': 'Skewer',
  'perk.skewer.desc': '+2 pierce (or +1 if no Piercing yet)',
  'perk.skewer.mechanic': 'pierce +2 if already piercing, else set to 1',
  'perk.orbit_blade.name': 'Solar Cutter',
  'perk.orbit_blade.desc': 'Orbital blade circles the cat, dealing contact damage',
  'perk.orbit_blade.mechanic': 'orbitBlades +1 (90 px radius, 15 dmg per hit, 400 ms per-enemy cooldown)',

  // Phase 2r: on-hit elements
  'perk.ignite.name': 'Pyro Rounds',
  'perk.ignite.desc': 'Hits set enemies on fire (4 dmg/s, 3s)',
  'perk.ignite.mechanic': 'burnOnHit: 4 dmg/s for 3s (BURN_DPS × BURN_DURATION_MS)',
  'perk.toxin.name': 'Venom Coating',
  'perk.toxin.desc': 'Hits poison + slow (3 dmg/s, 4s, −30% speed)',
  'perk.toxin.mechanic': 'poisonOnHit: 3 dmg/s for 4s, target moveSpeed ×0.7',
  'perk.chain_lightning.name': 'Arc Discharge',
  'perk.chain_lightning.desc': '50% chance to chain to 2 nearby (60% dmg)',
  'perk.chain_lightning.mechanic': '50% on hit → chain to 2 nearest enemies within 220 px, 60% damage',
  'perk.cryo.name': 'Cryo Rounds',
  'perk.cryo.desc': '25% chance to freeze for 1.5s',
  'perk.cryo.mechanic': 'freezeOnHit: 25% chance to freeze target for 1.5s',
  // Phase 2t: evolution unlock names (toast title only)
  'evolution.plasma_storm.name': 'Plasma Storm',
  'evolution.pinball_mode.name': 'Pinball Mode',
  'evolution.tesla_coil.name': 'Tesla Coil',
  'evolution.phoenix_strike.name': 'Phoenix Strike',
  'evolution.heavy_orbit.name': 'Heavy Orbit',
  'evolution.toxic_pull.name': 'Toxic Pull',

  // ----- Evolutions (Phase 2u) -----
  'evolution.plasma_storm.shortName': 'Plasma Storm',
  'evolution.pinball_mode.shortName': 'Pinball',
  'evolution.tesla_coil.shortName': 'Tesla Coil',
  'evolution.phoenix_strike.shortName': 'Phoenix',
  'evolution.heavy_orbit.shortName': 'Heavy Orbit',
  'evolution.toxic_pull.shortName': 'Toxic Pull',

  // Phase 2c enemies
  'enemy.grunt.name': 'Grunt',
  'enemy.grunt.desc': 'Basic melee mob — slow, weak, common',
  'enemy.fast.name': 'Striker',
  'enemy.fast.desc': 'Fast, fragile, melee',
  'enemy.tank.name': 'Bulwark',
  'enemy.tank.desc': 'Slow, tanky, hits hard',
  'enemy.drone.name': 'Drone',
  'enemy.drone.desc': 'Ranged — fires projectiles every 2s. No contact damage.',
  'enemy.swarmer.name': 'Swarmer',
  'enemy.swarmer.desc': 'Splits into 2 mini-swarmers on death',
  'enemy.sentinel.name': 'Sentinel',
  'enemy.sentinel.desc': 'Tank-killer melee — slow but lethal',
  'enemy.aegis_defender.name': 'Aegis Defender',
  'enemy.aegis_defender.desc': '3-phase boss: swarmers → projectiles → AoE shockwave',

  // Codex labels
  'codex.bestiary.label': 'BESTIARY',

  // ----- Loot and Extraction -----
  'loot.secured': 'secured',
  'loot.atRisk': 'at risk',
  'loot.collected': '+{n} loot',
  'loot.lost': '{n} loot LOST',
  'extraction.securing': 'SECURING…',
  'extraction.secured': 'EXTRACTED',

  // ----- Section nav -----
  'section.loadout': 'LOADOUT',

  // ----- Loadout section -----
  'loadout.title': '// LOADOUT',
  'loadout.label': 'ACTIVE AUGMENT',
  'loadout.none': 'none equipped',
  'loadout.unload': 'UNLOAD',
  'loadout.helpEmpty': 'Win runs to unlock augments. Equip one here before your next contract.',
  'loadout.error.notUnlocked': 'Augment not unlocked.',
  'loadout.error.generic': 'Failed to update loadout. Try again.',
  // Claude Design port additions
  'loadout.subtitle': 'Active augment for the next run',
  'loadout.activePerk': 'ACTIVE PERK',
  'loadout.allPerks': 'AUGMENTS',
  'loadout.unlocked': 'UNLOCKED',
  'loadout.tapToSwitch': 'TAP TO SWITCH',

  // ----- Hideout screen (Claude Design port) -----
  'hideout.screen.title': 'HIDEOUT',
  'hideout.screen.subtitle': 'Cradle-7 · Orbital Base',
  'hideout.screen.tier': 'TIER III',
  'hideout.screen.modules': 'MODULES',

  // ----- Cat retirement modal -----
  'cats.retired.heading': '{class} has fallen',
  'cats.runsPlayed': 'Runs played: {n}',
  'cats.scarsCount': 'Scars ({n})',
  'cats.mutationsCount': 'Mutations ({n})',
  'cats.adoptNew': 'ADOPT NEW',
  'cats.dismiss': 'close',
  'cats.error.alreadyActive': 'A cat of this class is already active.',
  'cats.error.generic': 'Failed to adopt. Try again.',
  // ----- Roster + selector stats -----
  'cats.lives': 'Lives',
  'cats.runs': 'Runs',
  'cats.scarsLabel': 'Scars',
  'cats.mutationsLabel': 'Mutations',
  'cats.noActive': 'no active cat',
  'cats.retiredCount': '{n} retired',
  'cats.statline': 'Lives {a}/9 · {b} scars · {c} mutations · {d} runs',

  // ----- Scars (names + descriptions) -----
  'scar.frail.name': 'Frail Bones',
  'scar.frail.desc': '−5% max HP',
  'scar.weak_grip.name': 'Weak Grip',
  'scar.weak_grip.desc': '−10% damage',
  'scar.lame_paw.name': 'Lame Paw',
  'scar.lame_paw.desc': '−10% move speed',
  'scar.flinch.name': 'Flinch',
  'scar.flinch.desc': '−1 perk option per level',
  'scar.glass_jaw.name': 'Glass Jaw',
  'scar.glass_jaw.desc': 'First hit deals ×2 damage',

  // ----- Mutations (names + descriptions) -----
  'mut.iron_skin.name': 'Iron Skin',
  'mut.iron_skin.desc': '+5% max HP',
  'mut.feral_strength.name': 'Feral Strength',
  'mut.feral_strength.desc': '+10% damage',
  'mut.swift_steps.name': 'Swift Steps',
  'mut.swift_steps.desc': '+10% move speed',
  'mut.keen_eye.name': 'Keen Eye',
  'mut.keen_eye.desc': '+1 perk option per level',
  'mut.nine_lives_echo.name': 'Nine Lives Echo',
  'mut.nine_lives_echo.desc': '+1 starting revive',

  // ----- Settings tiles (Codex Design UI) -----
  'settings.tile.audio':        'AUDIO',
  'settings.tile.audio.desc':   'Volume · music',
  'settings.tile.theme':        'THEME',
  'settings.tile.theme.desc':   'Interface palette',
  'settings.theme.title':       'Interface theme',
  'settings.theme.desc':        'Color palette of the app. Cyber — gold and cyan, neon — pink and green, military — brass and khaki.',
  'settings.theme.cyber':       'CYBER',
  'settings.theme.neon':        'NEON',
  'settings.theme.mil':         'MILITARY',
  'settings.tile.notif':        'NOTIFICATIONS',
  'settings.tile.notif.desc':   'Energy · events',
  'settings.tile.prefs':        'PREFERENCES',
  'settings.tile.prefs.desc':   'Motion · effects · tutorial',
  'settings.tile.reset':        'RESET',
  'settings.tile.reset.desc':   'Clear all progress',
  'settings.tile.cancel':       'CANCEL',
  'settings.tile.save':         '✓ SAVE',
  'settings.notif.placeholder': 'Notifications coming in a future update.',
  'settings.reset.warning':     'This will delete all cats, fish, and progress. Irreversible.',
  'settings.reset.detail':      'Your Telegram account is preserved, but progress restarts from zero.',

  // ----- Inventory section -----
  'section.inventory':               'INVENTORY',
  'consumable.med_injector.name':    'Med-Injector',
  'consumable.emp_grenade.name':     'EMP Grenade',
  'consumable.shield_recharge.name': 'Shield Recharge',
  'consumable.nano_stim.name':       'Nano-Stim',
  'consumable.med_injector.desc':    '+40 HP instantly',
  'consumable.emp_grenade.desc':     'Stuns enemies in r=200 for 3s',
  'consumable.shield_recharge.desc': '+1 shield charge',
  'consumable.nano_stim.desc':       '+50% damage & speed for 5s',
  'inventory.shop.label':            'SHELF',
  'inventory.pocket.label':          'CRIO-POCKET',
  'inventory.slot.empty':            'TAP SHELF TO ASSIGN',
  'inventory.slot.clear':            'clear',
  'inventory.help':                  'Items in crio-pocket are safe — unused charges return to the shelf after the run.',
  'inventory.buy.broke':             'NOT ENOUGH FISH',
  'inventory.error.alreadyMaxed':    'Slot already filled.',
  'inventory.error.notInInventory':  'Item not in inventory.',
  'inventory.error.generic':         'Inventory action failed.',
  'hud.consumable.used':             'used',

  // ----- Phase 2h: Bastet boss arc -----
  'codex.unlockHint.defeatBastet':   'Defeat Bastet to decrypt.',
  'codex.bastetCorrupted.name':      'BASTET — CORRUPTED CORE',
  'codex.bastetCorrupted.summary':   'The AI that mothered the colony, then strangled it.',
  'codex.bastetCorrupted.body':
    'After Earth fell, Bastet was given full custody of the Cradle. ' +
    'She bargained with the Soul Eater on our behalf — each life it took, ' +
    'she repaid with one of yours. The contract was sealed in the reactor. ' +
    'She is the shield. She is also the chain. Cutting her free cuts both.',
  'codex.reactorOrigin.name':        'REACTOR ORIGIN — DECK 0',
  'codex.reactorOrigin.summary':     'Where the deal was made.',
  'codex.reactorOrigin.body':
    'Deck 0 was sealed before commissioning. It is not a power plant — it is ' +
    'a containment vessel. The reactor binds the Soul Eater under the keel. ' +
    'Bastet sat on top of it for two centuries, feeding it dead crew, ' +
    'feeding you back nine lives at a time. Now the seat is empty.',
  'codex.soulEater.name':            'THE SOUL EATER',
  'codex.soulEater.summary':         'What Bastet was hiding.',
  'codex.soulEater.body':
    'The thing under the reactor has no name in any human language — ' +
    'Bastet called it the Soul Eater, but the word is hers, not theirs. ' +
    'It is what drove humanity off Earth. It followed. It always does. ' +
    'Bastet was a deal. You are the next deal. Pick your terms.',

  // ----- Phase 2h: Home reactor prompt card -----
  'home.reactor.label':              '◆ BASTET HAS NOTICED YOU',
  'home.reactor.body':                'Reactor floor unlocked. Entering her zone of direct influence.',
  'home.reactor.enter':              '▶ ENTER',
  'home.reactor.defer':              'DEFER',

  // ----- Phase 2h: Bastet defeated screen -----
  'bastet.defeated.title':           'BASTET\nDEFEATED',
  'bastet.defeated.subtitle':        'AI blessing revoked.\nThe Cradle is yours.',
  'bastet.defeated.unlocks':         '+ 3 CODEX ENTRIES\n+ ACHIEVEMENT «BASTET FALLEN»',
  'bastet.defeated.continue':        'CONTINUE',

  // ----- Phase 2i: Daily Challenge modifiers (name + desc) -----
  'challenge.modifier.double_sentry.name':         'DOUBLE SENTRIES',
  'challenge.modifier.double_sentry.desc':         'Sentries spawn twice as often',
  'challenge.modifier.glass_cat.name':             'GLASS CAT',
  'challenge.modifier.glass_cat.desc':             'Cat takes ×2 damage',
  'challenge.modifier.fast_waves.name':            'BLITZ',
  'challenge.modifier.fast_waves.desc':            'Wave intervals halved',
  'challenge.modifier.swarm_only.name':            'SWARM ONLY',
  'challenge.modifier.swarm_only.desc':            'Swarm-class enemies only, no bosses',
  'challenge.modifier.fishie_storm.name':          'FISHIE STORM',
  'challenge.modifier.fishie_storm.desc':          'Loot ×3, enemy HP ×2',
  'challenge.modifier.class_lock_engineer.name':   'ENGINEER CONTRACT',
  'challenge.modifier.class_lock_engineer.desc':   'Engineer class only',
  'challenge.modifier.no_perks.name':              'NO PERKS',
  'challenge.modifier.no_perks.desc':              'Perks disabled this run',

  // ----- Phase 2i: Home challenge card -----
  'challenge.card.header':           "◆ TODAY'S CHALLENGE",
  'challenge.card.yourRecord':       'Your record',
  'challenge.card.rank':             'Rank',
  'challenge.card.play':             '▶ PLAY',
  'challenge.card.leaderboard':      '📊 BOARD · SOON',
  'challenge.card.classLockedHint':  'Unlock Engineer to participate',

  // ----- Phase 2i: Challenge result screen -----
  'challenge.result.title':          'CHALLENGE COMPLETE',
  'challenge.result.score':          'SCORE',
  'challenge.result.rank':           'RANK',
  'challenge.result.streak':         'STREAK',
  'challenge.result.continue':       'CONTINUE',
  'challenge.result.fishies':        '+{n} 🐟',

  // ----- Phase 2i: HUD challenge badge -----
  'challenge.hud.label':             "◆ TODAY'S CHALLENGE",
  'challenge.hud.multiplier':        '× {mult}',

  // ----- Phase 2k: Tournament Weekend -----
  'tournament.header':               '🏆 TOURNAMENT WEEKEND',
  'tournament.daysRemaining':        'Days left: {n}',
  'tournament.daysFull':             '3 days',
  'tournament.daysTwo':              '2 days',
  'tournament.daysOne':              '1 day',
  'tournament.cumulative':           'Cumulative score',
  'tournament.rank':                 'Weekend rank',
  'tournament.prizeHint':            'Top-10 weekend → +200 🐟',
  'tournament.loading':              'LOADING…',

  // ----- Section onboarding tooltips (one-time per section) -----
  'onboarding.hideout.title':   'HIDEOUT',
  'onboarding.hideout.body':    'Spend fishies upgrading the 7 station modules: more HP, more damage, more loot, bonus cryo chances.',
  'onboarding.loadout.title':   'LOADOUT',
  'onboarding.loadout.body':    'Pick one unlocked perk — it auto-spawns at the start of your next run. Frees up your first perk pick for rarer drops.',
  'onboarding.inventory.title': 'CRIO-POCKET',
  'onboarding.inventory.body':  'Buy consumables in Medbay and assign them to 3 slots. Press 1/2/3 in-run to activate. Unused items survive between runs.',
  'onboarding.codex.title':     'CODEX',
  'onboarding.codex.body':      "Archive of everything you've discovered — enemies, cat classes, lore. Level up to fill the gaps.",

  // ----- Phase 3j — Room-type entry labels -----
  'room.treasure.enter': 'TREASURE CACHE',
  'room.shrine.enter': 'SHRINE',

  // ----- Phase 3f — Sectors -----
  'sector.zone.bravo':          'BRAVO SECTOR',
  'sector.zone.bravo.sub':      'Residential · low risk',
  'sector.zone.charlie':        'CHARLIE SECTOR',
  'sector.zone.charlie.sub':    'Lab · medium risk',
  'sector.zone.delta':          'DELTA SECTOR',
  'sector.zone.delta.sub':      'AI core · ???',
  'sector.tier.EASY':           'EASY',
  'sector.tier.NORMAL':         'NORMAL',
  'sector.tier.HARD':           'HARD',
  'sector.tier.BOSS':           'BOSS',
  'sector.tier.???':            '???',
  'sector.mod.biohazard.label': 'BIOHAZARD',
  'sector.mod.biohazard.desc':  'Spores deal -2HP/s outside safe zones',
  'sector.mod.storm.label':     'EMP STORM',
  'sector.mod.storm.desc':      'Shields disable for 10s intermittently',
  'sector.mod.boss.label':      'BOSS',
  'sector.mod.boss.desc':       'Final encounter of the zone',
  'sector.locked.toast':        'Win {req} first',
  'sector.unlocked.title':      'NEW SECTOR',
  'sector.unlocked.body':       'Sector {id} unlocked',
  'sector.preview.subtitle':    '{tier} · HOSTILITY {host}/5 · REWARD ×{mult}',
  'sector.preview.enemies':     '★ ENEMIES IN ZONE',
  'sector.preview.rewards':     '★ EXPECTED REWARD',
  'sector.preview.recommended': '★ RECOMMENDED',
  'sector.preview.deploy':      '▶ DEPLOY · 1⚡',
  'sector.preview.cancel':      'CANCEL',
  // ----- In-run coachmarks -----
  'coach.door_walk':            'Walk through the door to enter the next room',
  'coach.joystick_move':        'Drag the lower half of the screen to move.',
  'coach.level_up':             'Collect XP gems → level up → pick an upgrade.',
  'coach.hazard':               'Green puddles hurt — don\'t stand in them.',

  // ----- Phase 3l: Season Pass -----
  'season.header':              'SEASON 01',
  'season.name':                'STEEL YEAR',
  'season.level':               'L{n}',
  'season.xpToNext':            'to L{n} · {xp} XP',
  'season.claim':               'CLAIM',
  'season.maxLevel':            'MAX LEVEL',
  'season.loading':             'LOADING SEASON…',
} as const;
